// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__1hDAE","editableWrapper":"Modal_editableWrapper__F6yVQ","button":"Modal_button__4Kflc"};